export default __webpack_public_path__ + "static/media/0000..0007.c825b7c4.png";